import React from 'react';

import styles from './styles/styles.module.scss';
import { wrapEventHandler } from '../../../../utils/handlers';

export default function Badge({ title, children, className, handleClick }) {
  const classes = [styles.badge];
  if (className) {
    classes.push(className);
  }
  if (handleClick) {
    classes.push(styles.clickable);
  }

  return (
    <span title={title} className={classes.join(' ')} onClick={wrapEventHandler(handleClick)}>
      {children}
    </span>
  );
}
